import { PlantLayoutEditorThemeModeConfig } from './types';

const light: PlantLayoutEditorThemeModeConfig = {
  plantLayoutEditor: {},
};

export default light;
